import React from "react";
import "./Deposite_info_card.css";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Deposite_info_card() {
  return (
    <>
      <section className="Deposite_info_card">
        {/* Info Box */}
        <div className="Withdraw_deposite_bank_info deposit_card_box">
          <div className="info_box">
            <div className="section_header">
              <span className="icon_box"><FontAwesomeIcon icon={faBook} /></span>
              <h4>Recharge Instructions</h4>
            </div>

            <p>
              <span className="red">•</span> Need to bet{" "}
              <span className="red">₹2.33</span> to be able to withdraw
            </p>
            <p>
              <span className="red">•</span> Withdraw time{" "}
              <span className="red">00:00-23:55</span>
            </p>
            <p>
              <span className="red">•</span> In day Remaining Withdrawal{" "}
              <span className="red">Times 3</span>
            </p>
            <p>
              <span className="red">•</span> Withdrawal amount range{" "}
              <span className="red">₹10.00 - ₹10,000,000.00</span>
            </p>
            <p>
              <span className="red">•</span> Please confirm your beneficial
              account information before withdrawing. If your information is
              incorrect, our company will not be liable for the amount of loss
            </p>
            <p>
              <span className="red">•</span> If your beneficial information is
              incorrect, please contact customer service
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Deposite_info_card;
